var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "quit")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "quit",
    fill: "#F55000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0 C114.835938,0 0,114.835938 0,256 C0,397.164062 114.835938,512 256,512 C397.164062,512 512,397.164062 512,256 C512,114.835938 397.164062,0 256,0 Z M350.273438,320.105469 C358.613281,328.449219 358.613281,341.929688 350.273438,350.273438 C346.113281,354.433594 340.652344,356.523438 335.1875,356.523438 C329.726562,356.523438 324.265625,354.433594 320.105469,350.273438 L256,286.164062 L191.894531,350.273438 C187.734375,354.433594 182.273438,356.523438 176.8125,356.523438 C171.347656,356.523438 165.886719,354.433594 161.726562,350.273438 C153.386719,341.929688 153.386719,328.449219 161.726562,320.105469 L225.835938,256 L161.726562,191.894531 C153.386719,183.550781 153.386719,170.070312 161.726562,161.726562 C170.070312,153.386719 183.550781,153.386719 191.894531,161.726562 L256,225.835938 L320.105469,161.726562 C328.449219,153.386719 341.929688,153.386719 350.273438,161.726562 C358.613281,170.070312 358.613281,183.550781 350.273438,191.894531 L286.164062,256 L350.273438,320.105469 Z",
    id: "Shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.2f300365.svg";
export { ForwardRef as ReactComponent };